import { useState } from 'react';
import { Plus } from 'lucide-react';
import { UploadModal } from './UploadModal';
import { useDocumentStore } from '@/lib/stores';

export function FloatingAddButton() {
  const [showModal, setShowModal] = useState(false);
  const { currentWeekKey } = useDocumentStore();

  return (
    <>
      <button
        onClick={() => setShowModal(true)}
        className="fixed bottom-6 right-6 w-14 h-14 bg-purple-600 hover:bg-purple-700 text-white rounded-full shadow-lg hover:shadow-xl flex items-center justify-center z-40 transition-all hover:scale-105 active:scale-95"
        title="Add Evidence"
      >
        <Plus className="w-6 h-6" />
      </button>

      <UploadModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        weekKey={currentWeekKey}
      />
    </>
  );
}
